import { Box, VStack, Text } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import Thumbnails from '../Thumbnails';
import { thumbnails } from '../../data/thumbnails';
const Home = () => {
	const { id } = useParams();
	return (
		<VStack>
			<Box textAlign='center' w='full' bg='#161616'>
				<Text
					fontSize='3xl'
					fontFamily='monteserrat'
					fontWeight='bold'
					fontStyle='italic'
					color='#a3a3a3'
					p={3}>
					{id}
				</Text>
			</Box>
			{id && <Thumbnails data={thumbnails[id]} />}
		</VStack>
	);
};

export default Home;
